<template>
  <div>
    <div>
      <div class="step">
        <span class="circle">1</span>
        <span class="step-title">下载模板，填写题目、选项、正确答案</span>
        <Button type="default" @click="downloadTemplate(1)">下载Excel模板</Button>
        <Button type="default" @click="downloadTemplate(2)">下载Word模板</Button>
      </div>
      <div class="tips">
        <div class="tip">
          <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
          <span>请按照模板样式填写</span>
        </div>
        <div class="tip">
          <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
          <span>单选题、多选题、判断题、简答题Excel页请勿出现整行为空、单元格为空的情形</span>
        </div>
        <div class="tip">
          <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
          <span>一次最多支持导入300道试题，单选、多选、判断题、简答题请分表格填写</span>
        </div>
        <div class="tip">
          <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
          <span>单选题、多选题最多支持6个选择 ，判断题只支持2个选择，简答题只需填写答案和解析</span>
        </div>
        <div class="tip">
          <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
          <span>为确保您的试题导入正常，建议下载新的模板导入</span>
        </div>
      </div>
    </div>
    <div>
      <div class="step">
        <span class="circle">2</span>
        <span class="step-title">Word导入说明：</span>
      </div>
      <div class="tips">
        <div class="tip">
          <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
          <span>【】符号为关键符号，针对不同题型此符号和符号中的内容是必填的。</span>
        </div>
        <div class="tip">
          <div style="padding-left:40px;">例如：【单选题】必定有选项【A】【B】（选项后紧跟大写英文字母）；【答案】（关键字后紧跟答案）；【解析】（关键字后紧跟解析内容）。</div>
        </div>
        <div class="tip">
          <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
          <span>多题之间要换行，并使用6个“#”号区分。（######）</span>
        </div>
        <div class="tip">
          <i class="ivu-icon ivu-icon-ios-alert-outline"></i>
          <span>上传的word文件必须为docx格式。其他格式均不支持导入。</span>
        </div>
      </div>
    </div>
    <div>
      <div class="step step2">
        <span class="circle">3</span>
        <span class="step-title">上传填写好的模板</span>
        <UploadFile
          label="上传文件"
          :url="'/api/import/question/'+$route.query.bank"
          :format="['xlsx','docx']"
          :showIcon="false"
          @onSuccess="onSuccess"
        ></UploadFile>
      </div>
    </div>

    <Modal v-model="showResultModal" title="导入结果">
      <div v-if="errors&&errors.length">
        <div>
          <UploadFile
            label="重新上传"
            :url="'/api/import/question/'+$route.query.bank"
            :format="['xlsx','docx']"
            :showIcon="false"
            @onSuccess="onSuccess"
          ></UploadFile>
        </div>
        <div style="padding-top:10px;">
          <span>共{{total}}条，其中有{{errors.length}}条不符要求，请修改后重新上传</span>
          <a
            class="lnk-detail"
            @click="showDetail=true"
            style="cursor:pointer;margin-left:20px;"
          >失败详情</a>
        </div>
        <div v-if="showDetail">
          <div class="error" v-for="(error,index) in errors" :key="index">
            <span>{{index+1}}、{{error}}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div style="display:flex;align-items:center;">
          <UploadFile
            label="继续上传"
            :url="'/api/import/question/'+$route.query.bank"
            :format="['xlsx','docx']"
            :showIcon="false"
            @onSuccess="onSuccess"
          ></UploadFile>
          <router-link
            :to="{name:'QuestionBankTopic',query:{id:$route.query.bank}}"
            style="margin-left:20px;"
          >查看试题</router-link>
        </div>
        <div style="padding-top:10px;">
          <span>共{{total}}条，全部导入成功</span>
        </div>
      </div>
      <template v-slot:footer>
        <Button type="primary" @click="showResultModal=false">确定</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
import UploadFile from "@/components/UploadFile.vue";

export default {
  name: "QuestionBankTopicImport",
  components: {
    UploadFile
  },
  data() {
    return {
      showResultModal: false,
      total: 0,
      showDetail: false,
      errors: []
    };
  },
  methods: {
    downloadTemplate(type) {
      let baseUrl = process.env.BUILD_ENV == "dev" ? "/" : "/adminstyle/";
      if( type == 1 ) {
        window.open(baseUrl + "doc/试题导入模板.xlsx");
      }else {
        window.open(baseUrl + "doc/word试题导入模板.docx");
      }
    },
    onSuccess(data) {
      if (data.err) {
        this.errors = data.err;
        this.total = data.total;
      } else {
        this.total = data;
      }
      this.showDetail = false;
      this.showResultModal = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.step {
  display: flex;
  .circle {
    display: inline-block;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: 50%;
    background-color: #0094ff;
    color: white;
  }
  .step-title {
    font-size: 16px;
    margin: 0 15px;
  }
}
.step2 {
  .circle,
  .step-title {
    margin-bottom: 8px;
  }
}
.tips {
  padding-left: 32px;
  padding-top: 20px;
  .tip {
    color: #969191;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    i {
      font-size: 20px;
      margin-right: 15px;
    }
  }
}
.error {
  padding-top: 10px;
}
</style>
